// UnvisitedSiteCardConfig.js
import { Truck, Activity } from "lucide-react";

export const TRANSIT_CARD_CONFIG  = [
      {
    key: "total",
    title: "Currently in Transit",
    icon: Truck,
    bg: "bg-amber-100",
    color: "text-amber-600",
  },
  {
    key: "todayDispatched",
    title: "Dispatched Today",
    icon: Activity,
    bg: "bg-blue-2",
    color: "text-[#2e45a8]",
  },

];